import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MensagensService } from "max-ng-lib";
import { GenericRoteirizadorService } from "src/app/core/services/generic-roteirizador.service";

@Injectable({ providedIn: 'root' })
export class AtualizacaoService  extends GenericRoteirizadorService {


    constructor(private _mensagensService: MensagensService,
        private _httpClient: HttpClient) {
        super();
      }
    getMensagensService(): MensagensService {
        return this._mensagensService;
    }

    getHttpClient(): HttpClient {
        return this._httpClient;
    }

    getUrlRecurso(): string {
        return '/atualizacao';
      }

    processar() {
        return this.get<any>('/processar');
    }
}